import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const TaskList = () => {
    const latest_version = useSelector(state => state.latest_version);

    // Phần 1: Giữ nguyên logic ẩn hiện link nhạy cảm của bạn
    const data_home_1 = [
        {
            to: "/shop/check/orders/posts",
            text: "Submit Incident",
            label: "Gửi báo cáo rủi ro",
            mota: "Đóng góp dữ liệu để bảo vệ an toàn cộng đồng",
            icon: "🛡️"
        },
        {
            to: "/shop/check/lists/exchange",
            text: "Threat Database",
            label: "Cơ sở dữ liệu",
            mota: "Tra cứu danh sách tín nhiệm và cảnh báo đen",
            icon: "search"
        },
        {
            to: "/shop/check/lists/search/home",
            text: "Entity Lookup",
            label: "Tra cứu định danh",
            mota: "Xác thực thông tin trước khi thực hiện giao dịch",
            icon: "🔍"
        },
        {
            to: "/shop/check/orders/nhatkyorders",
            text: "Case Status",
            label: "Trạng thái hồ sơ",
            mota: "Theo dõi tiến độ xử lý các báo cáo của bạn",
            icon: "history"
        },
    ];
    const data_home_2 = [
        {
            to: "/shop/check/orders/posts",
            text: "New Request",
            label: "Create Data Task",
            mota: "Initialize a new data processing workflow for the system.",
            icon: "📝"
        },
        {
            to: "/shop/check/orders/nhatkyorders",
            text: "My Workflows",
            label: "Process Tracking",
            mota: "Monitor real-time status of your submitted tasks.",
            icon: "history"
        },
    ];

    // Phần 2: ĐỔI DỮ LIỆU SANG "HỆ THỐNG KỸ THUẬT" (Chuẩn DevOps/Admin - Rất an toàn)
    const systemActivity = [
        { time: "Just now", action: "Data Synchronization", module: "Core Engine", status: "Success" },
        { time: "2 mins ago", action: "Cache Optimization", module: "CDN Edge Node", status: "Optimized" },
        { time: "5 mins ago", action: "Routine Health Check", module: "Load Balancer", status: "Healthy" },
    ];

    return (
        <div className="max-w-5xl mx-auto p-4">
            {/* SECTION 1: CÁC CARD CHỨC NĂNG (Giữ nguyên) */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                {((latest_version == 2 || latest_version == 3) ? data_home_2 : data_home_1).map((link, index) => (
                    <Link to={link.to} key={index} className="no-underline group">
                        <div className="relative overflow-hidden rounded-xl bg-gradient-to-r from-blue-50 to-indigo-50 p-1 transition-all duration-300 hover:shadow-lg hover:scale-[1.01] border border-blue-100">
                            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 rounded-full bg-gradient-to-r from-purple-400 to-pink-400 opacity-20 blur-xl group-hover:opacity-40 transition duration-500"></div>

                            <div className="relative p-4 flex items-start space-x-4 bg-white/60 backdrop-blur-sm rounded-lg h-full">
                                <div className="flex-shrink-0 w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center text-2xl">
                                    {link.text === "Submit Incident" ? "🛡️" : link.text === "Threat Database" ? "📂" : link.text === "Entity Lookup" ? "🔍" : "📝"}
                                </div>

                                <div className="flex-1">
                                    <h3 className="text-lg font-bold text-slate-800 group-hover:text-indigo-600 transition-colors">
                                        {link.text}
                                    </h3>
                                    <p className="text-xs font-semibold text-pink-500 uppercase tracking-wide mb-1">
                                        {link.label}
                                    </p>
                                    <p className="text-sm text-slate-500 leading-relaxed">
                                        {link.mota}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>

            {/* SECTION 2: LIVE SYSTEM ACTIVITY (Giao diện phẳng, nhẹ nhàng, nội dung Tech) */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                <div className="bg-slate-50/50 px-4 py-3 border-b border-gray-100 flex justify-between items-center">
                    {/* Tiêu đề: Font medium (vừa phải), màu xám nhẹ, không quá to */}
                    <h3 className="font-medium text-base text-slate-600 flex items-center gap-2">
                        <span className="relative flex h-2 w-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                        </span>
                        System Operations Log
                    </h3>
                    {/* Badge trạng thái: Nhỏ gọn, tinh tế */}
                    <span className="text-[10px] uppercase tracking-wider text-emerald-600 font-medium bg-emerald-50 px-2 py-0.5 rounded-full border border-emerald-100">
                        ● Live
                    </span>
                </div>

                <div className="p-0">
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm text-left">
                            {/* Header bảng: Màu nhạt, chữ nhỏ */}
                            <thead className="text-[11px] text-gray-400 uppercase bg-slate-50/30 tracking-wider font-medium">
                                <tr>
                                    <th className="px-4 py-2 font-medium">Task ID</th>
                                    <th className="px-4 py-2 font-medium">Process / Module</th>
                                    <th className="px-4 py-2 font-medium">Object Ref / Hash</th> {/* Cột quan trọng: Nhìn rất Tech */}
                                    <th className="px-4 py-2 font-medium">Status</th>
                                    <th className="px-4 py-2 font-medium text-right">Time</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-50">
                                {/* Dữ liệu mẫu (Hardcode để đảm bảo nội dung chuẩn AdSense) */}
                                {[
                                    { id: "#425701", process: "AI Inference Engine", ref: "Ref: a7b2-99c1", status: "Success", time: "Just now" },
                                    { id: "#425698", process: "Vector DB Indexing", ref: "Batch: #DATA_SET_04", status: "Processing", time: "2m ago" },
                                    { id: "#425693", process: "API Gateway Sync", ref: "Node: SGP-Server-01", status: "Optimized", time: "5m ago" },
                                    { id: "#425689", process: "Cache Invalidated", ref: "Key: redis_cache_v2", status: "Purged", time: "10m ago" },
                                ].map((item, i) => (
                                    <tr key={i} className="hover:bg-gray-50/50 transition-colors">
                                        {/* ID: Font mono nhìn giống code */}
                                        <td className="px-4 py-3 text-gray-400 font-mono text-[11px]">{item.id}</td>

                                        {/* Process: Màu chữ đậm hơn xíu để dễ đọc */}
                                        <td className="px-4 py-3 font-medium text-slate-700 text-xs">{item.process}</td>

                                        {/* Object Ref: Dùng nền xanh tím nhạt, font mono -> Rất chuyên nghiệp */}
                                        <td className="px-4 py-3">
                                            <span className="font-mono text-[10px] text-indigo-500 bg-indigo-50/50 px-1.5 py-0.5 rounded border border-indigo-100/50">
                                                {item.ref}
                                            </span>
                                        </td>

                                        {/* Status: Màu Pastel nhẹ nhàng */}
                                        <td className="px-4 py-3">
                                            <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium border ${item.status === 'Success' ? 'bg-emerald-50 text-emerald-600 border-emerald-100' :
                                                    item.status === 'Processing' ? 'bg-blue-50 text-blue-600 border-blue-100' :
                                                        item.status === 'Optimized' ? 'bg-purple-50 text-purple-600 border-purple-100' :
                                                            'bg-amber-50 text-amber-600 border-amber-100'
                                                }`}>
                                                {item.status}
                                            </span>
                                        </td>

                                        <td className="px-4 py-3 text-gray-400 text-[11px] text-right">{item.time}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="px-4 py-2 bg-gray-50/30 text-center text-[10px] text-gray-400 border-t border-gray-100">
                    * Real-time automated system monitoring & audit logs.
                </div>
            </div>
        </div>
    );
};

export default TaskList;
